<template>
  <div>
    <div class="mb-4">
      <slot />
    </div>
    <div v-for="child in item.children"
         :key="child.id" :class="`ml-${depth * DEPTH_MARGIN}`" class="mb-4">
      <span
        :class="{
          'font-weight-medium': isSection(child),
          'text-text-primary': isSection(child),
          'text-text-secondary': !isSection(child),
        }"
      >
        {{ `${child.display}. ${(child.title || '')}` }}
      </span>
      <SavedChecklistPreviewAttachments v-if="child.nbAttachments" :task="child"/>

      <SavedChecklistPreviewItem v-if="child.children"
                                  :item="child"
                                  :depth="depth + 1"
      />
    </div>
  </div>
</template>

<script>
  import SavedChecklistPreviewAttachments from '@/project/checklist/dialogs/SavedChecklistPreviewAttachments.vue'

  const DEPTH_MARGIN = 3

  export default {
    name: 'SavedChecklistPreviewItem',
    components: {
      SavedChecklistPreviewAttachments,
    },
    props: {
      item: {
        type: Object,
        required: true,
      },
      depth: {
        type: Number,
        required: true,
      },
    },
    data () {
      return {
        DEPTH_MARGIN,
      }
    },
    methods: {
      isSection (child) {
        return child.type === 'title'
      },
    },
  }
</script>
